import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const useResendEmailChangeConfirmationLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post(`sessions/resend_change_email_confirmation`);
      return data;
    },
    retry: 1,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['resend-email-change-confirmation-link'],
      });
    },
  });
};

export default useResendEmailChangeConfirmationLink;
